const company = {
  title: "Company Details",
  description:
    "Tell us more to create your company profile by providing the information below.",
  enName: {
    label: "Company English Name",
    placeholder: "e.g. Yoram Global",
  },
  arName: {
    label: "Company Arabic Name",
    placeholder: "Company Arabic Name",
  },
  city: {
    label: "Registered City",
    placeholder: "Select your city",
  },
  commercialRecord: {
    label: "Commercial Record",
    placeholder: "12345-67890",
  },
  logo: {
    shortLabel: "Logo",
    label: "Company Logo",
    hint: "SVG, PNG, JPG or GIF (max. 800×400px)",
  },
  uploadFile: {
    label: "CR Document Upload",
    clickToUpload: "Click to upload",
    dragHint: "or drag and drop",
    hint: "PDF only (one file).",
    uploading: "Uploading",
  },
  delegationDocumentUrl: {
    label: "Delegation Document Upload",
    clickToUpload: "Click to upload",
    dragHint: "or drag and drop",
    hint: "PDF only — max 5MB (one file).",
  },
  personalIdUrl: {
    label: "Personal ID Document Upload",
    clickToUpload: "Click to upload",
    dragHint: "or drag and drop",
    hint: "PDF, JPG or PNG — max 5MB (one file).",
  },
  actions: {
    createCompany: "Create Company",
  },
};

export default company;
